import React, {ReactElement, ReactNode} from "react";
import MoodImage from "./login-page-mood.png";
import Div100vh from "react-div-100vh";

export interface CoverMoodFormProps {
    children: ReactNode
}

export function CoverMoodForm(props: CoverMoodFormProps): ReactElement {
    return (
        <Div100vh className="w-screen grid grid-rows-1 grid-cols-5">
            <div className="col-span-3">
                <img
                    src={MoodImage}
                    alt="Mood"
                    className="object-cover w-full min-h-full"
                />
            </div>
            <div className="col-span-2 bg-warm-gray pt-7 pb-10 pl-10 pr-12">
                {props.children}
            </div>
        </Div100vh>
    );
}